import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserTypeLookupComponent } from './user-type-lookup/user-type-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [UserTypeLookupComponent],
  exports: [UserTypeLookupComponent]
})
export class UserTypeLookupModule { }
